// extracted by mini-css-extract-plugin
export var wordContainer = "_ks-0";